/**
 * Inline 16x16 Heroicons-outline style SVGs. stroke=currentColor,
 * strokeWidth=1.5, fill=none. No emojis, no external icon libs.
 * Size via Tailwind (e.g. className="w-4 h-4").
 */
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base: SVGProps<SVGSVGElement> = {
	viewBox: "0 0 16 16",
	stroke: "currentColor",
	strokeWidth: 1.5,
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
};

export function Layers(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 2L2 5l6 3 6-3-6-3z" />
			<path d="M2 8l6 3 6-3" />
			<path d="M2 11l6 3 6-3" />
		</svg>
	);
}

export function Megaphone(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M3 6v4l8 3V3L3 6z" />
			<path d="M3 6H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1" />
			<path d="M5 11v1.5a1.5 1.5 0 0 0 3 0V12" />
		</svg>
	);
}

export function Sparkle(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 2v3M8 11v3M2 8h3M11 8h3" />
			<path d="M8 5.5l1 1.5 1.5 1L9 9l-1 1.5L7 9l-1.5-1L7 7l1-1.5z" />
		</svg>
	);
}

export function BarChart(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M2 13h12" />
			<path d="M4 13V9" />
			<path d="M7 13V6" />
			<path d="M10 13V8" />
			<path d="M13 13V4" />
		</svg>
	);
}

export function Link2(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M6.5 9.5L9.5 6.5" />
			<path d="M5 7.5L3.5 9a2.5 2.5 0 0 0 3.5 3.5L8.5 11" />
			<path d="M11 8.5L12.5 7a2.5 2.5 0 0 0-3.5-3.5L7.5 5" />
		</svg>
	);
}

export function Shield(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 2l5 2v4c0 3-2 5-5 6-3-1-5-3-5-6V4l5-2z" />
		</svg>
	);
}

export function Users(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<circle cx="6" cy="6" r="2.5" />
			<path d="M2 13c0-2 2-3.5 4-3.5S10 11 10 13" />
			<path d="M10.5 5a2 2 0 0 1 0 4" />
			<path d="M12 13c0-1.5-1-3-2.5-3.5" />
		</svg>
	);
}

export function Check(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M3 8.5L6.5 12 13 4" />
		</svg>
	);
}

export function Gear(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<circle cx="8" cy="8" r="2" />
			<path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.5 3.5l1.5 1.5M11 11l1.5 1.5M3.5 12.5L5 11M11 5l1.5-1.5" />
		</svg>
	);
}

export function CreditCard(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<rect x="1.5" y="4" width="13" height="9" rx="1.5" />
			<path d="M1.5 7h13" />
			<path d="M4 10.5h2.5" />
		</svg>
	);
}

export function Bell(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 2a4 4 0 0 1 4 4v2l1 2H3l1-2V6a4 4 0 0 1 4-4z" />
			<path d="M6.5 12a1.5 1.5 0 0 0 3 0" />
		</svg>
	);
}

export function Search(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<circle cx="7" cy="7" r="4.5" />
			<path d="M10.5 10.5L14 14" />
		</svg>
	);
}

export function Question(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<circle cx="8" cy="8" r="6" />
			<path d="M6.25 6a1.75 1.75 0 1 1 2.5 1.5c-.5.3-.75.75-.75 1.25V9.5" />
			<path d="M8 11.5h.01" />
		</svg>
	);
}

export function ChevronDown(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M4 6l4 4 4-4" />
		</svg>
	);
}

export function ArrowUp(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 13V3" />
			<path d="M4 7l4-4 4 4" />
		</svg>
	);
}

export function ArrowDown(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 3v10" />
			<path d="M4 9l4 4 4-4" />
		</svg>
	);
}

export function Plus(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M8 3v10M3 8h10" />
		</svg>
	);
}

export function Home(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M2 7l6-5 6 5v6a1 1 0 0 1-1 1h-3v-4H6v4H3a1 1 0 0 1-1-1V7z" />
		</svg>
	);
}

export function Zap(p: IconProps) {
	return (
		<svg {...base} {...p}>
			<path d="M9 1.5L3 9h4l-1 5.5L12 7H8l1-5.5z" />
		</svg>
	);
}
